/**
 * List Schema of ResponsavelHistoricoSms
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelHistoricoSms} from '@/model/resource/ResponsavelHistoricoSms'

/* TODO: review generated schema */
export class ListResponsavelHistoricoSmsSchema extends Schema {
  readonly name = 'ListResponsavelHistoricoSms'

  readonly fieldSet: FieldSet<ResponsavelHistoricoSms> = {
    idHistoricoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    typeSms: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.typeSms?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    nomeDestinatario: (): FieldComponent => ({
      is: Component.Render,
    }),
    mensagem: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataEnvio: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataEnvio),
      },
    }),
    nfe: (): FieldComponent => ({
      is: Component.Render,
    }),
    telefone: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.phone(schema.model.telefone),
      },
    }),
  }
}
